import { render, staticRenderFns } from "./SingleLayerComplexStyle.vue?vue&type=template&id=79842bea&scoped=true"
import script from "./SingleLayerComplexStyle.vue?vue&type=script&lang=ts"
export * from "./SingleLayerComplexStyle.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerComplexStyle.vue?vue&type=style&index=0&id=79842bea&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "79842bea",
  null
  ,true
)

export default component.exports